import { MinimumGroupOrderSize } from '../constants'
import preOrderConstraints from '../constraints/preOrderConstraints'

/** Same rules as the group order form: a name and a size within the limits */
export default function isGroupOrderDetailsValid(
  groupOrderName: string | null | undefined,
  groupOrderSize: number | null | undefined,
  maxGroupSize: number | null | undefined,
) {
  const name = groupOrderName?.trim() ?? ''

  if (!name || name.length > preOrderConstraints.max.groupOrderName) {
    return false
  }

  if (!groupOrderSize || groupOrderSize < MinimumGroupOrderSize) {
    return false
  }

  return !maxGroupSize || groupOrderSize <= maxGroupSize
}
